"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.icon.help': 'Inserisci classe icona FontAwesome (es. fas fa-folder)',
};
